// The fixed `.event-stats-bar` row every event module shows between the sub-controls
// strip and the body (so the counts never scroll away) — ported from renderers-shotmap.js
// renderEventModule / renderers-heatmap.js. Like PopulationReadout it's a real sibling
// inserted just before the body, filled through a portal. Hidden (not removed) in the
// empty states, as the legacy does.

import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

interface Props {
  mod: HTMLElement;
  body: HTMLElement;
  hidden: boolean;
  children?: ReactNode;
}

export function EventStatsBar({ mod, body, hidden, children }: Props) {
  const [el] = useState(() => {
    const d = document.createElement("div");
    d.className = "event-stats-bar";
    return d;
  });

  useEffect(() => {
    mod.insertBefore(el, body);
    return () => el.remove();
  }, [mod, body, el]);

  useEffect(() => {
    el.style.display = hidden ? "none" : "";
  }, [el, hidden]);

  return createPortal(hidden ? null : children, el);
}
